import React from 'react';
import { motion } from 'framer-motion';
import { ChevronRight, ChevronLeft } from 'lucide-react';

const DiagnosticCards = ({
  Icon,
  title,
  status,
  onClick,
  isMaintenanceCard = false,
  isSelected = false,
}) => {
  return (
    <motion.div
      whileHover={{
        scale: 1.02,
        backgroundColor: isSelected 
          ? (status === "True" ? '#14532d' : status === "False" ? '#ef4444' : 'rgb(23 88 255)')
          : (status === "True" ? '#dcfce7' : status === "False" ? '#fee2e2' : 'rgb(147 197 253)'),
      }}
      animate={{
        scale: isSelected ? 1.02 : 1,
        backgroundColor: isSelected 
          ? (status === "True" ? '#14532d' : status === "False" ? '#ef4444' : 'rgb(23 88 255)') 
          : (status === "True" ? '#f0fdf4' : status === "False" ? '#fef2f2' : 'rgb(243 244 246)'),
      }}
      transition={{
        backgroundColor: { duration: 0.15 },
        scale: { duration: 0.3 },
      }}
      whileTap={{ scale: 0.98 }}
      className={`
    group rounded-lg p-2 flex items-center gap-3 cursor-pointer
    h-[60px] w-full relative z-9 overflow-hidden
    ${isSelected ? 'text-white shadow-lg' : status === "True" ? 'text-green-800' : status === "False" ? 'text-red-800' : 'text-blue-800'}
  `}
      onClick={onClick}
    >
      <div className={`w-8 h-8 ml-3 flex-shrink-0 flex items-center justify-center ${isSelected ? 'text-white' : status === "True" ? 'text-green-600' : status === "False" ? 'text-red-600' : 'text-blue-800'}`}>
        <Icon className="w-full h-full" />
      </div>

      <div className={`w-[2px] h-[75%] absolute left-16 top-1/2 -translate-y-1/2 ${isSelected ? 'bg-white' : status === "True" ? 'bg-green-500' : status === "False" ? 'bg-red-500' : 'bg-red-500'
        }`}
      />

      <div className="flex-1 overflow-hidden p-2">
        <h3
          className={`font-semibold mb-1 pl-2 truncate text-sm ${isSelected ? 'text-white' : status === "True" ? 'text-green-800' : status === "False" ? 'text-red-800' : 'text-blue-800'
            }`}
        >
          {title}
        </h3>
      </div>
    </motion.div>
  );
};

export default DiagnosticCards;

